/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Letter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import LetterRecipientPicker from 'DesignSystem/LetterRecipientPicker/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import Status from './Status/index'
import Template from './Template/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Letter({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let letterRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let letterPostalAddressIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'postal_address_id',
})
let onSave = fromHelpers.useOnSave({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Letter.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z2o3zsO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z2o3zsO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-Z2o3zsO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-Z2o3zsO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-5-Z2o3zsO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-6-Z2o3zsO': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Letter.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Template
  viewPath={`${viewPath}/Template`}
/>
</div>
<div
  data-testid="Letter.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<LetterRecipientPicker
  viewPath={`${viewPath}/LetterRecipientPicker`}
 autoSelect={true}
 data="patient.id"
 patientId={patientIdValueData}
 data="letter.recipient_id"
 recipientId={letterRecipientIdValueData}
 data="letter.postal_address_id"
 postalAddressId={letterPostalAddressIdValueData}
 onSave={onSave}
/>
</div>
<div
  data-testid="Letter.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
<div
  data-testid="Letter.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
<div
  data-testid="Letter.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}